import { render, staticRenderFns } from "./SearchSidebar.vue?vue&type=template&id=f2ed5352&scoped=true"
import script from "./SearchSidebar.vue?vue&type=script&lang=js"
export * from "./SearchSidebar.vue?vue&type=script&lang=js"
import style0 from "./SearchSidebar.vue?vue&type=style&index=0&id=f2ed5352&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed5352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2ed5352')) {
      api.createRecord('f2ed5352', component.options)
    } else {
      api.reload('f2ed5352', component.options)
    }
    module.hot.accept("./SearchSidebar.vue?vue&type=template&id=f2ed5352&scoped=true", function () {
      api.rerender('f2ed5352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/SearchSidebar.vue"
export default component.exports